import { AHSeparator, Box, Circle, Input, SectionHeader, useTheme } from "arkh";
import React from "react";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { ColorSelect } from "../TeamIdentifiers/TeamIdentifiersComponent";

export function PLUCategoryIdentifiers({
  title,
  setTitle,
  color,
  setColor,
  usedColors,
  autoFocus,
}: {
  autoFocus?: boolean;
  title: string;
  setTitle(title: string): void;
  color: string;
  setColor(color: string): void;
  usedColors: string[];
}) {
  const palette = useTheme().colorScheme;
  const intl_tokens = useIntlTokens();
  return (
    <>
      <Circle
        size="xlarge"
        style={{
          backgroundColor: color,
          alignSelf: "center",
        }}
      />
      <Box spaceHorizontal="medium">
        <SectionHeader>
          <SectionHeader.Title>{intl_tokens.Title}</SectionHeader.Title>
        </SectionHeader>
        <Input
          autoFocus={autoFocus}
          spaceHorizontal="medium"
          autoCapitalize="sentences"
          returnKeyType="done"
          value={title}
          onChangeText={setTitle}
        />
      </Box>
      <AHSeparator />
      <ColorSelect
        spaceHorizontal="medium"
        selectedColor={color}
        setSelectedColor={setColor}
        palette={palette}
        usedColors={usedColors}
        usedSectionTitle="Används för andra kategorier"
      />
    </>
  );
}
